"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _SVGIcon = _interopRequireDefault(require("@instructure/ui-svg-images/lib/components/SVGIcon"));

var _ref =
/*#__PURE__*/
_react.default.createElement("path", {
  d: "M219.03 0H1801.44v1920H219.03v-439.216h-56.514c-31.196 0-56.515-25.299-56.515-56.47 0-31.172 25.319-56.47 56.515-56.47h56.514V1029.02h-56.514c-31.196 0-56.515-25.3-56.515-56.471 0-31.172 25.319-56.47 56.515-56.47h56.514V577.254h-56.514c-31.196 0-56.515-25.299-56.515-56.47 0-31.172 25.319-56.471 56.515-56.471h56.514V0zm1469.382 1807.059V112.94H332.059v351.373h56.515c31.196 0 56.514 25.299 56.514 56.47 0 31.172-25.318 56.47-56.514 56.47h-56.515v338.824h56.515c31.196 0 56.514 25.3 56.514 56.471 0 31.172-25.318 56.47-56.514 56.47h-56.515v338.824h56.515c31.196 0 56.514 25.299 56.514 56.47 0 31.172-25.318 56.471-56.514 56.471h-56.515v326.275h1356.353zM1461.96 734.118v508.235H558.43v-903.53h621.177v112.942H671.373v677.647h677.647V734.118h112.94zM889.315 622.114l145.017 145.13 352.602-352.603 79.85 79.85-432.452 432.451-224.866-224.979 79.85-79.85z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconGradebook =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(IconGradebook, _Component);

  function IconGradebook() {
    (0, _classCallCheck2.default)(this, IconGradebook);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(IconGradebook).apply(this, arguments));
  }

  (0, _createClass2.default)(IconGradebook, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_SVGIcon.default, Object.assign({}, this.props, {
        name: "IconGradebook",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);
  IconGradebook.displayName = "IconGradebook";
  return IconGradebook;
}(_react.Component);

exports.default = IconGradebook;
IconGradebook.glyphName = 'gradebook';
IconGradebook.variant = 'Line';
IconGradebook.propTypes = (0, _objectSpread2.default)({}, _SVGIcon.default.propTypes);